import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesService } from './services/utilities.service';
import { DialogService } from './services/dialog.service';
import { NavigationService } from './services/navigation.service';
import { AuthService } from './services/auth.service';
import { AuthGuard } from '../guards/auth.guard';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        UtilitiesService,
        DialogService,
        NavigationService,
        AuthService,
        AuthGuard
      ]
    };
  }
}
